import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useVideo } from "../contexts/VideoContext";
import { MessageCircle, Heart, Reply } from "lucide-react";

interface CommentSectionProps {
  videoId: string;
}

export const CommentSection: React.FC<CommentSectionProps> = ({ videoId }) => {
  const [newComment, setNewComment] = useState("");
  const { user } = useAuth0();
  const { comments, addComment } = useVideo();
  
  const videoComments = comments.filter(comment => comment.videoId === videoId);

  const handleAddComment = () => {
    if (!newComment.trim()) return;
    addComment(videoId, newComment);
    setNewComment("");
  };

  return (
    <div className="comment-section">
      <div className="comment-header">
        <MessageCircle size={20} />
        <span>{videoComments.length} komentarzy</span>
      </div>

      {user && (
        <div className="add-comment">
          <img 
            src={user.picture || "/default-avatar.png"} 
            alt="Your avatar" 
            className="comment-avatar"
          />
          <div className="comment-input-container">
            <textarea
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              placeholder="Dodaj komentarz..."
              rows={3}
            />
            <div className="comment-actions">
              <button onClick={() => setNewComment("")}>Anuluj</button>
              <button onClick={handleAddComment} disabled={!newComment.trim()}>
                Komentuj
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="comments-list">
        {videoComments.map(comment => (
          <div key={comment.id} className="comment">
            <img 
              src={comment.avatar || "/default-avatar.png"} 
              alt={comment.username} 
              className="comment-avatar"
            />
            <div className="comment-content">
              <div className="comment-header">
                <span className="comment-username">{comment.username}</span>
                <span className="comment-time">
                  {new Date(comment.timestamp).toLocaleDateString()}
                </span>
              </div>
              <p className="comment-text">{comment.text}</p>
              <div className="comment-actions">
                <button className="comment-action">
                  <Heart size={16} />
                  {comment.likes}
                </button>
                <button className="comment-action">
                  <Reply size={16} />
                  Odpowiedz
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
